module.exports = __webpack_public_path__ + "static/media/shift-icon.4402d07a.svg";